import * as React from 'react'
import styled, { css } from 'styled-components'
import { Color } from '../../../constants/app.constant'
import { Icon } from '../../atoms/icon'

function Spinner() {
  return (
    <Portal>
      <LoadingInner
        css={css`
          position: fixed;
          top: 0;
          bottom: 0;
          right: 0;
          left: 0;
          display: flex;
          flex-direction: column;
          background-color: rgba(255, 255, 255, 0.4);
          justify-content: center;
          align-items: center;
          color: ${Color.BRAND.PRIMARY};
        `}
      >
        <LoadingIcon>
          <Icon.Loading size={'25px'} />
        </LoadingIcon>
      </LoadingInner>
    </Portal>
  )
}

const LoadingIcon = styled.div`
  svg {
    animation: rotateAnimation 2s linear infinite;
  }
  @keyframes rotateAnimation {
    0% {
      transform: rotateZ(0deg);
    }
    100% {
      transform: rotateZ(-360deg);
    }
  }
`

const LoadingInner = styled.div<{
  css: any
}>`
  ${({ css }) => css};
`
const Portal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 9999;
`

export default Spinner



// WEBPACK FOOTER //
// ./src/components/organisms/spinner/spinner.tsx